var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","fade":"","variant":_vm.variantAlert},on:{"dismiss-count-down":_vm.countDownChanged}},[_vm._v(" "+_vm._s(_vm.textAlert)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }